import React from "react";
import { motion } from "framer-motion";
import Counters from "../components/Counters";

const timeline = [
  {
    year: "2023",
    title: "Begining of Aspen Plush Homes",
    description:
      "Aspen Plush Homes was founded with a vision to redefine modern luxury living in Africa.",
    image: "/luxe3.jpg",
  },
  {
    year: "2024",
    title: "Progressing",
    description:
      "Delivered our first luxury residential complex, setting the standard for quality and design.",
    image: "/luxe11.jpeg",
  },
  {
    year: "2025",
    title: "Expansion",
    description:
      "Expanded into new regions, introducing innovative architectural concepts and smart homes.",
    image: "/luxeheights.jpg",
  },
  {
    year: "2026",
    title: "Trusted Brand",
    description:
      "Recognized as one of the most trusted real estate developers for premium projects.",
    image: "/luxeheights.jpg",
  },
];

export default function About() {
  return (
    <div className="bg-white">
      {/* Hero Banner */}
      <section
        className="relative h-[60vh] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: "url('/luxeheights.jpg')" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative z-10 text-center text-white px-6"
        >
          <h1 className="text-4xl md:text-6xl font-bold">
            About Aspen Plush Homes
          </h1>
          <p className="mt-4 max-w-2xl mx-auto text-lg md:text-xl text-gray-200">
            Redefining luxury living with innovative design, quality, and
            passion for excellence.
          </p>
        </motion.div>
      </section>

      {/* About Content */}
      <section className="max-w-6xl mx-auto py-20 px-6 grid md:grid-cols-2 gap-12 items-center">
        <motion.img
          src="/luxeheights.jpg"
          alt="Luxury Interior"
          className="rounded-2xl shadow-lg"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        />
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Who We Are
          </h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            At Aspen Plush Homes, we believe a home should be more than just a
            place to live — it should be a sanctuary of comfort, style, and
            sophistication.
          </p>
          <p className="text-gray-600 leading-relaxed">
            With years of experience in real estate and design, we are committed
            to delivering projects that blend modern architecture, luxury
            interiors, and sustainable living.
          </p>
        </motion.div>
      </section>

      {/* Timeline */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16">
            Our Journey
          </h2>
          <div className="relative">
            {/* vertical line */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 h-full w-1 bg-blue-600/40" />

            <div className="space-y-16">
              {timeline.map((item, index) => {
                const isLeft = index % 2 === 0;
                return (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: isLeft ? -100 : 100 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className={`relative flex flex-col md:flex-row items-center ${
                      isLeft ? "md:justify-start" : "md:justify-end"
                    }`}
                  >
                    {/* Dot */}
                    <div className="absolute left-1/2 -translate-x-1/2 w-6 h-6 bg-blue-600 rounded-full border-4 border-white z-10 shadow" />

                    {/* Card */}
                    <div
                      className={`bg-white rounded-2xl shadow-md p-6 md:w-5/12 ${
                        isLeft ? "md:mr-auto md:pr-12" : "md:ml-auto md:pl-12"
                      }`}
                    >
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-40 object-cover rounded-xl shadow mb-4"
                      />
                      <h3 className="text-xl font-semibold text-gray-900">
                        {item.year} — {item.title}
                      </h3>
                      <p className="mt-2 text-gray-600">{item.description}</p>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Counters */}
      <Counters />
    </div>
  );
}
